var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var lib_geometry = require("lib-geometry");

var PackageStateMachine = function (root, model) {
    var self = this;

    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(self);


    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MODEL_MAKE_BOX;
        },
        function(cEvent){
            self.root.rec();
            
            if(self.root.data.ipcParametricData()) {
                self.root.data.isIPCDataAnd3DModelOutOfSync(true);
                self.root.data.is3dModelUploadedManually(true);
            }
            
            //note: before creating box set is3dModelUploadedManually to true to detect event that custom model is removed correctly using onChange listener on model3d
            self.model.buildDefaultBoxForCurrentFootprint();
            self.root.stopRec();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MODEL_REMOVE;
        },
        function(cEvent){
            self.root.rec();
            self.root.data.model3d(null);
            self.root.stopRec();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MODEL_PLACE_DOWN;
        },
        function(cEvent){
            self.root.rec();
            self.model.placeDown();
            self.root.stopRec();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MODEL_PLACE_CENTER;
        },
        function(cEvent){
            self.root.rec();
            self.model.center();
            self.root.stopRec();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MODEL_CLONE_POSITION;
        },
        function(cEvent){
            if(!self.model.switcherModel.selectedItem()) return;
            var currentpos = self.model.switcherModel.selectedItem().data.model3dPosition().clone();
            var currentrot = self.model.switcherModel.selectedItem().data.model3dRotation().clone();
            self.root.rec();
            self.model.data.footprintInstances.forEach(function(idx, instance){
                instance.model3dPosition(currentpos.clone());
                instance.model3dRotation(currentrot.clone());
            });
            self.root.stopRec();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MODEL_RESET_VIEW;
        },
        function(cEvent){
            self.model.resetCamera();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MODEL_BOARD_EXPORT_FOOTPRINT;
        },
        function(cEvent){
            self.model.exportFootprint();
        }
    );
    
    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CLOSE_XREF_OBJ_MODAL;
        },

        function(cEvent){
            self.model.xrefObjModalShown(false);
        }
    );
    
    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CLOSE_EMPTY_OBJ_MODAL;
        },

        function(cEvent){
            self.model.emptyObjModalShown(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CLOSE_EMPTY_OBJ_LINKED_MODAL;
        },

        function(cEvent){
            self.model.emptyObjLinkedModalShown(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CLOSE_FUSION_LINKED_MODAL;
        },

        function(cEvent){
            self.model.fusionLinkedModalShown(false);
        }
    );
};

lib_core.inherit(PackageStateMachine, lib_core.StateMachine);

module.exports = PackageStateMachine;